
import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import '../App.css';

class About extends Component{
	render(){
		return (
			<div>
				<p className="bread">
				<Link to="/">หน้าแรก</Link> > เกี่ยวกับเรา
				</p>
				<p>
				เราเป็นเว็บไซต์บอลสด นำเสนอทั้งบอลไทย 
				และบอลต่างประเทศ มีบอลบุนเดสลีกา พรีเมียร์ลีก ลาลีก้า กัลโช่เซเรียอา 
				วิเคราะห์ผลการแข่งขันนาทีต่อนาที มีบอลสดให้ดูแบบนาทีต่อนาที วินาทีต่อวินาที 
				ใครยิง ใครจ่าย ใครดาวซัลโว ใครแฮททริก คุณจะไม่พลาดอีกต่อไป
				</p>
				<p>
				มีโปรแกรมให้ดูล่วงหน้า มีตารางบอล คะแนนบอล เพื่อให้แฟนบอลทุกท่านไม่พลาดโอกาส ในการติดตามข่าวสารฟุตบอล 
				ของทีมรัก อนาคตเรายังมีไฮไลท์ฟุตบอล ตารางถ่ายทอดสดฟุตบอล ตารางบอลวันนี้ โปรแกรมบอลวันนี้ ดูบอลออนไลน์ ให้ท่านได้ติดตาม 
				ดูบอลผ่านมือถือได้ตลอดเวลา หากท่านไม่สะดวกดูบอลผ่านคอมพิวเตอร์ รับประกันความลื่น ความคมชัด ตลอด 24 ชั่วโมง
				</p>
            </div>
		);
	}
}

export default About;
